export default "__VITE_ASSET__26525rxc__"